var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('div',{staticClass:"menu-title"},[_vm._v(_vm._s(_vm.item.header))]),_c('ul',_vm._l((_vm.item.children),function(item,index){return _c('sub-menu',{key:index,attrs:{"item":item,"collapsed":_vm.collapsed}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }